import React, { useState, useEffect, useRef } from "react"
import { graphql } from "gatsby"

import Background from "../components/Background/Background"
import "../App.css"

import { Canvas } from "@react-three/fiber"

import LayerGreenVoiceOrbit from "../components/Layers/LayerGreenVoiceOrbit"
import Modal from "../components/Modal/Modal"
import MainMenu from "../components/MainMenu/MainMenu"
import Title from "../components/Title/Title"

import { LanguageProvider } from "../components/LanguageContext"
import Seo from "../components/seo"


const GreenTalk = ({ data }) => {
  const [show, setShow] = useState(false)

  const helpData = [
    {
      language: "IT",
      body: data.strapiHelp.ContentITA,
    },
    {
      language: "EN",
      body: data.strapiHelp.ContentENG,
    },
  ]
  const [contentModal, setContentModal] = useState(helpData)

  const [language, setLanguage] = useState("IT")
  const handleModal = content => {
    setShow(true)
    setContentModal(content)
    //console.log(content)
  }
  function refreshPage() {
    window.location.reload(false)
  }

  const titlesPositions = [
    [0, -5, -20],
    [5, -5, -15],
    [-5, -5, -15],
    [0, -5, -30],
    [5, -5, -25],
    [-5, -5, -25],
    [0, -5, -40],
    [5, -5, -35],
    [-5, -5, -35],
  ]


  useEffect(() => {
    const timer = setTimeout(() => {
      handleModal(contentModal)
    }, 1000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <Seo />

      <LanguageProvider value={[language, setLanguage]}>
        <MainMenu handleModal={handleModal} show={show} />

        <Canvas className="MainCanvas" shadowMap colorManagement>
          <LanguageProvider value={[language, setLanguage]}>
            <Background />
            {data.allStrapiWord.nodes.map((el, idx) => {
              if (idx < 3) {
                return (
                  <>
                    <Title
                      key={idx}
                      handleModal={handleModal}
                      position={titlesPositions[idx]}
                      rotation={[0, 0, 0]}
                      titleITA={el.TitleITA}
                      titleENG={el.TitleENG}
                      modalContentIT={el.TestoITA}
                      modalContentEN={el.TestoENG}
                      icon={el.icon.localFile.publicURL}
                    />
                    <group position={[0, 0, 0]} rotation={[0, Math.PI, 0]}>
                      <Title
                        key={idx}
                        handleModal={handleModal}
                        position={titlesPositions[idx]}
                        rotation={[0, 0, 0]}
                        titleITA={el.TitleITA}
                        titleENG={el.TitleENG}
                        modalContentIT={el.TestoITA}
                        modalContentEN={el.TestoENG}
                        icon={el.icon.localFile.publicURL}
                      />
                    </group>
                  </>
                )
              } else {
                return (
                  <>
                    <group position={[0, 0, 0]} rotation={[0, Math.PI / 2, 0]}>
                      <Title
                        key={idx}
                        handleModal={handleModal}
                        position={titlesPositions[idx]}
                        rotation={[0, 0, 0]}
                        titleITA={el.TitleITA}
                        titleENG={el.TitleENG}
                        modalContentIT={el.TestoITA}
                        modalContentEN={el.TestoENG}
                        icon={el.icon.localFile.publicURL}
                      />
                    </group>
                    <group position={[0, 0, 0]} rotation={[0, -Math.PI / 2, 0]}>
                      <Title
                        key={idx}
                        handleModal={handleModal}
                        position={titlesPositions[idx]}
                        rotation={[0, 0, 0]}
                        titleITA={el.TitleITA}
                        titleENG={el.TitleENG}
                        modalContentIT={el.TestoITA}
                        modalContentEN={el.TestoENG}
                        icon={el.icon.localFile.publicURL}
                      />
                    </group>
                  </>
                )
              }
            })}
            <LayerGreenVoiceOrbit
              greenTalks={data.allStrapiGreenVoice.nodes}
              handleModal={handleModal}
              depth={-5}
              show={show}
            />
          </LanguageProvider>
        </Canvas>
        <Modal
          handleClose={() => {
            setShow(false)
          }}
          show={show}
          content={contentModal}
        />
        <div className="Layer-title">
          <h1>GREEN VOICES</h1>
        </div>
      </LanguageProvider>
    </>
  )
}

export const query = graphql`
  {
    allStrapiGreenVoice {
      nodes {
        Active
        Title
        ContentITA
        ContentENG
        videoID
        speakers {
          bioENG
          bioITA
          cognome
          nome
          cover {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 200, placeholder: BLURRED)
              }
            }
          }
        }
        Cover {
          localFile {
            childImageSharp {
              gatsbyImageData(width: 1000, placeholder: BLURRED)
            }
          }
        }
      }
    }
    strapiHelp {
      ContentITA
      ContentENG
    }
    allStrapiWord {
      nodes {
        TitleITA
        TitleENG
        TestoITA
        TestoENG
        icon {
          localFile {
            publicURL
          }
        }
      }
    }
  }
`

export default GreenTalk
